// fr_pms_reports.ts
// Traductions pour PMS.Reports – Snapshot des rapports opérationnels en direct

export const frPmsReports = {

  title: "Rapports",
  subtitle: "Instantane en direct du reporting operationnel depuis le backend Ops PMS.",

  // ── Indicateurs ───────────────────────────────────────────────────────────
  metrics: {
    occupancy:        "Occupation",
    reservations:     "Réservations",
    checkedIn:        "Arrivées enregistrées",
    checkedOut:       "Départs enregistrés",
    currentProperty:  "Établissement actuel",
    liveStatus:       "Statut en direct",
  },

  // ── Tableau principal ─────────────────────────────────────────────────────
  primary: {
    title:              "Performance operationnelle",
    subtitle:           "Activite hoteliere actuelle depuis l'instantane de rapports Ops PMS.",
    arrivalsToday:      "Arrivées aujourd'hui",
    departuresToday:    "Départs aujourd'hui",
    totalCharges:       "Total des charges",
    totalPayments:      "Total des paiements",
    outstandingBalance: "Solde impayé",
  },

  // ── Tableau des segments de marché ────────────────────────────────────────
  marketSegment: {
    title:            "Mix des segments de marché",
    subtitle:         "Mix de réservations en direct par segment de marché depuis le backend Ops PMS.",
    emptyLabel:       "Segments de marché",
    emptyValue:       "0 enregistrement de segment de marché en direct",
    reservationCount: "{{count}} réservation(s)",
  },

  // ── Tableau des sources et pickup ─────────────────────────────────────────
  sourcePickup: {
    title:              "Production par source",
    subtitle:           "Production de reservations en direct par source/canal depuis le backend Ops PMS.",
    emptySourceLabel:   "Production des sources",
    emptySourceValue:   "0 enregistrement de source/canal en direct",
    reservationCount:   "{{count}} réservation(s)",
  },

  pickup: {
    title:      "Pickup (7j)",
    subtitle:   "Reservations creees par jour sur les 7 derniers jours.",
    emptyValue: "0 ligne de pickup en direct",
  },

  meta: {
    generatedAt: "Instantane genere",
  },

} as const;

export default frPmsReports;
